import { HttpErrorResponse } from '@angular/common/http';
import { Action } from '@ngrx/store';

import { GetSearchResults } from '@shared/models/get-search-results';
import { GetSearchResultsParams } from '@shared/models/get-search-results-params';
import { SearchResult } from '@shared/models/search/search-result';

// Get Results
export const GET_RESULTS = '[Entertainment Search] Get Results';
export const GET_RESULTS_SUCCESS = '[Entertainment Search] Get Results Success';
export const GET_RESULTS_FAILURE = '[Entertainment Search] Get Results Failure';

export const GET_TEN_EVENTS = '[Ten Entertainment Events] Get ten events';
export const GET_TEN_EVENTS_SUCCESS = '[Ten Entertainment Events] Get ten events success';
export const GET_TEN_EVENTS_FAILURE = '[Ten Entertainment Events] Get ten events failure';

export class GetResults implements Action {
  readonly type = GET_RESULTS;

  constructor(public payload: GetSearchResultsParams) {}
}

export class GetResultsSuccess implements Action {
  readonly type = GET_RESULTS_SUCCESS;

  constructor(public payload: GetSearchResults) {}
}

export class GetResultsFailure implements Action {
  readonly type = GET_RESULTS_FAILURE;

  constructor(public payload: { error: HttpErrorResponse }) {}
}

export class GetTenEvents implements Action {
  readonly type = GET_TEN_EVENTS;
  constructor(public layout?: string) {}
}

export class GetTenEventsSuccess implements Action {
  readonly type = GET_TEN_EVENTS_SUCCESS;
  constructor(public results: SearchResult[]) {}
}
export class GetTenEventsFailure implements Action {
  readonly type = GET_TEN_EVENTS_FAILURE;
}

export type MemberEventsSearchActions =
  | GetResults
  | GetResultsSuccess
  | GetResultsFailure
  | GetTenEvents
  | GetTenEventsSuccess
  | GetTenEventsFailure;
